/**
 * @generated SignedSource<<2eab3869d040fe021b06dd55c213c13a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type infographicArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"blockquoteLongReadContent" | "globalCheckerContent" | "landingBannerInfographicArticle">;
  readonly " $fragmentType": "infographicArticleArticle";
};
export type infographicArticleArticle$key = {
  readonly " $data"?: infographicArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"infographicArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "infographicArticleArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "landingBannerInfographicArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "blockquoteLongReadContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "131aad8cfa912d6c6d34e9ef6b01951c";

export default node;
